module.exports = __webpack_public_path__ + "static/media/Modal18Mais.e69ffccd.png";